import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'homeleite-root',
    template: `
        <homeleite-env-banner></homeleite-env-banner>
        <router-outlet></router-outlet>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
    title = 'admin';
    isLoggedIn = true;
}
